/**
 * Calculate selected slot validation status.
 *
 * Determines whether the currently selected time slot is available for instant approval
 * and whether to show an unavailable banner to the user.
 *
 * @param params.selectedDateTime - Currently selected date/time in HH:mm format
 * @param params.availableSlots - List of available time slots (in HH:mm format)
 * @param params.autoConfirmUnavailable - Whether auto-confirm is unavailable (query error or quantity exceeded)
 *
 * @returns Selected slot validation status containing:
 *   - isAvailable: true if selected slot is in availableSlots list
 *   - showUnavailableBanner: true when slot is not available BUT could be selected from available slots
 *                           (false if auto-confirm is unavailable or no slots available)
 */
export const calculateSelectedSlotValidation = (params: {
  selectedDateTime: string
  availableSlots: string[]
  autoConfirmUnavailable: boolean
}) => {
  const isAvailable = params.availableSlots.includes(params.selectedDateTime)

  return {
    isAvailable,
    showUnavailableBanner:
      !params.autoConfirmUnavailable && !isAvailable && params.availableSlots.length > 0
  }
}
